<template>
  <UiTabBar
    :tabs="tabs"
    class="project-tab-bar__tab-bar"
    @click:tab="handleTabClick"
  />

  <UiProfileModalSmart
    v-if="isOpenProfile"
    @visible:user-menu="sendAcademicaShowBurgerMenu"
    @click:item="(value: string) => sendAcademicaClickBurgerMenu({link: value})"
    @click:theme="$emit('click:theme')"
  />

  <UiCatalogModalSmart
    v-if="isOpenCatalog"
    @click:direction="(index: number) => sendAcademicaClickMenu('header', {
      selected_direction_id: directionsWithQuery[index]?.slug || '',
    })"
    @visible:navigation="sendAcademicaShowMenu('header', {})"
    @click:banner="(value: string) => sendAcademicaClickMenuBanner({link: value})"
    @visible:banner="sendAcademicaShowBanner({})"
  />
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'

  import type { Tab } from '@academica-box/components/Blocks/UiTabBar/types'

  import { useDirectionsStore } from '@academica-box/composables/store/directions'

  import UiTabBar from '@academica-box/components/Blocks/UiTabBar/UiTabBar.vue'
  import UiProfileModalSmart from '@academica-box/components/Smarts/UiProfileModal.smart/UiProfileModal.smart.vue'
  import UiCatalogModalSmart from '@academica-box/components/Smarts/UiCatalogModal.smart/UiCatalogModal.smart.vue'

  import {
    sendAcademicaShowBurgerMenu,
    sendAcademicaClickBurgerMenu,
    sendAcademicaShowMenu,
    sendAcademicaClickMenu,
    sendAcademicaShowBanner,
    sendAcademicaClickMenuBanner,
  } from '@/pages/analytics'

  const emit = defineEmits([
    'click:tab',
    'click:theme',
  ])

  const config = useRuntimeConfig()

  const directionsStore = useDirectionsStore()
  const { directionsWithQuery } = storeToRefs(directionsStore)

  const isOpenCatalog = ref(false)
  const isOpenProfile = ref(false)

  const tabs = computed(() => {
    return [
      {
        link: `${config.public.frontUrl}`,
        title: 'Академика',
        isActive: false,
        icon: 'ui-home'
      },
      {
        link: `${config.public.frontUrl}/catalog/`,
        action: 'open-catalog',
        isActive: isOpenCatalog.value,
        title: 'Каталог',
        icon: 'ui-burger-search'
      },
      {
        link: `${config.public.frontUrl}/vendors/`,
        isActive: false,
        title: 'Партнёры',
        icon: 'ui-university'
      },
      {
        link: '/profile-menu/',
        action: 'open-profile-menu',
        isActive: isOpenProfile.value,
        title: 'Профиль',
        icon: 'ui-user'
      },
    ]
  })

  const handleTabClick = (tab: Tab) => {
    if (tab.action === 'open-catalog') {
      isOpenProfile.value = false
      isOpenCatalog.value = !isOpenCatalog.value
    } else if (tab.action === 'open-profile-menu') {
      isOpenCatalog.value = false
      isOpenProfile.value = !isOpenProfile.value
    } else {
      isOpenProfile.value = false
      isOpenCatalog.value = false
    }

    emit('click:tab', tab)
  }
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiZIndex' as *;

  .project-tab-bar__tab-bar {
    @include z-index(navigation, tab-bar);

    background-color: var(--bg-main-color);
  }
</style>
